import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { GET } from "../../Utilities/BaseService";

export interface RecoveryPlan {
    // id: number;
    // team: string;
    // contact: string;
    // supportTeam: string;
    // supportContact: string;
    date: string;
    village: string;
    hamlet: {
        name: string;
        id: number | string;
        countOfConsumers: { [consumerType: string]: number };
        countOfDefaulters: number;
    }[];
    // consumerTypes: string[];
}

// const mockData: RecoveryPlan[] = [
//     {
//         id: 1,
//         team: "Alpha Team",
//         contact: "123-456-7890",
//         supportTeam: "Support Squad A",
//         supportContact: "321-654-0987",
//         date: "2025-05-01",
//         village: "Greenfield",
//         hamlet: [
//             {
//                 name: "Hamlet One",
//                 id: 101,
//                 countOfConsumers: { residential: 150, commercial: 20 },
//                 countOfDefaulters: 5,
//             },
//             {
//                 name: "Hamlet Two",
//                 id: 102,
//                 countOfConsumers: { residential: 100, commercial: 10 },
//                 countOfDefaulters: 3,
//             },
//         ],
//         consumerTypes: ["residential", "commercial"],
//     },
//     {
//         id: 2,
//         team: "Beta Team",
//         contact: "555-123-4567",
//         supportTeam: "Support Squad B",
//         supportContact: "555-765-4321",
//         date: "2025-05-02",
//         village: "Sunnyvale",
//         hamlet: [
//             {
//                 name: "Hamlet Alpha",
//                 id: 201,
//                 countOfConsumers: { residential: 200, industrial: 15 },
//                 countOfDefaulters: 10,
//             },
//             {
//                 name: "Hamlet Beta",
//                 id: 202,
//                 countOfConsumers: { residential: 180, industrial: 5 },
//                 countOfDefaulters: 2,
//             },
//         ],
//         consumerTypes: ["residential", "industrial"],
//     },
//     {
//         id: 3,
//         team: "Gamma Team",
//         contact: "444-222-1111",
//         supportTeam: "Support Squad C",
//         supportContact: "444-333-2222",
//         date: "2025-05-03",
//         village: "Riverdale",
//         hamlet: [
//             {
//                 name: "Hamlet East",
//                 id: 301,
//                 countOfConsumers: { residential: 120, agricultural: 30 },
//                 countOfDefaulters: 4,
//             },
//             {
//                 name: "Hamlet West",
//                 id: 302,
//                 countOfConsumers: { residential: 140, agricultural: 20 },
//                 countOfDefaulters: 6,
//             },
//         ],
//         consumerTypes: ["residential", "agricultural"],
//     },
//     {
//         id: 4,
//         team: "Delta Team",
//         contact: "333-111-2222",
//         supportTeam: "Support Squad D",
//         supportContact: "333-444-5555",
//         date: "2025-05-04",
//         village: "Mapleton",
//         hamlet: [
//             {
//                 name: "Hamlet North",
//                 id: 401,
//                 countOfConsumers: { residential: 90, commercial: 12 },
//                 countOfDefaulters: 1,
//             },
//             {
//                 name: "Hamlet South",
//                 id: 402,
//                 countOfConsumers: { residential: 80, commercial: 8 },
//                 countOfDefaulters: 2,
//             },
//         ],
//         consumerTypes: ["residential", "commercial"],
//     },
//     {
//         id: 5,
//         team: "Epsilon Team",
//         contact: "222-333-4444",
//         supportTeam: "Support Squad E",
//         supportContact: "222-555-6666",
//         date: "2025-05-05",
//         village: "Brookfield",
//         hamlet: [
//             {
//                 name: "Hamlet Green",
//                 id: 501,
//                 countOfConsumers: { residential: 110, agricultural: 15 },
//                 countOfDefaulters: 0,
//             },
//             {
//                 name: "Hamlet Blue",
//                 id: 502,
//                 countOfConsumers: { residential: 130, agricultural: 10 },
//                 countOfDefaulters: 1,
//             },
//         ],
//         consumerTypes: ["residential", "agricultural"],
//     },
//     {
//         id: 6,
//         team: "Zeta Team",
//         contact: "777-888-9999",
//         supportTeam: "Support Squad F",
//         supportContact: "777-666-5555",
//         date: "2025-05-06",
//         village: "Lakeside",
//         hamlet: [
//             {
//                 name: "Hamlet Lakeview",
//                 id: 601,
//                 countOfConsumers: { residential: 180, industrial: 20 },
//                 countOfDefaulters: 7,
//             },
//         ],
//         consumerTypes: ["residential", "industrial"],
//     },
//     {
//         id: 7,
//         team: "Eta Team",
//         contact: "888-999-0000",
//         supportTeam: "Support Squad G",
//         supportContact: "888-777-6666",
//         date: "2025-05-07",
//         village: "Hilltop",
//         hamlet: [
//             {
//                 name: "Hamlet Peak",
//                 id: 701,
//                 countOfConsumers: { residential: 160, commercial: 25 },
//                 countOfDefaulters: 3,
//             },
//         ],
//         consumerTypes: ["residential", "commercial"],
//     },
//     {
//         id: 8,
//         team: "Theta Team",
//         contact: "999-000-1111",
//         supportTeam: "Support Squad H",
//         supportContact: "999-888-7777",
//         date: "2025-05-08",
//         village: "Oakwood",
//         hamlet: [
//             {
//                 name: "Hamlet Central",
//                 id: 801,
//                 countOfConsumers: { residential: 190, industrial: 18 },
//                 countOfDefaulters: 5,
//             },
//         ],
//         consumerTypes: ["residential", "industrial"],
//     },
//     {
//         id: 9,
//         team: "Iota Team",
//         contact: "000-111-2222",
//         supportTeam: "Support Squad I",
//         supportContact: "000-999-8888",
//         date: "2025-05-09",
//         village: "Pinehill",
//         hamlet: [
//             {
//                 name: "Hamlet Pine",
//                 id: 901,
//                 countOfConsumers: { residential: 170, agricultural: 40 },
//                 countOfDefaulters: 6,
//             },
//         ],
//         consumerTypes: ["residential", "agricultural"],
//     },
//     {
//         id: 10,
//         team: "Kappa Team",
//         contact: "111-222-3333",
//         supportTeam: "Support Squad J",
//         supportContact: "111-000-9999",
//         date: "2025-05-10",
//         village: "Elmwood",
//         hamlet: [
//             {
//                 name: "Hamlet Elm",
//                 id: 1001,
//                 countOfConsumers: { residential: 200, commercial: 30 },
//                 countOfDefaulters: 8,
//             },
//         ],
//         consumerTypes: ["residential", "commercial"],
//     },
//     {
//         id: 11,
//         team: "Lambda Team",
//         contact: "222-333-4445",
//         supportTeam: "Support Squad K",
//         supportContact: "222-111-0000",
//         date: "2025-05-11",
//         village: "Stonefield",
//         hamlet: [
//             {
//                 name: "Hamlet Rock",
//                 id: 1101,
//                 countOfConsumers: { residential: 120, industrial: 10 },
//                 countOfDefaulters: 2,
//             },
//         ],
//         consumerTypes: ["residential", "industrial"],
//     },
//     {
//         id: 12,
//         team: "Mu Team",
//         contact: "333-444-5556",
//         supportTeam: "Support Squad L",
//         supportContact: "333-222-1111",
//         date: "2025-05-12",
//         village: "Windmere",
//         hamlet: [
//             {
//                 name: "Hamlet Breeze",
//                 id: 1201,
//                 countOfConsumers: { residential: 130, agricultural: 15 },
//                 countOfDefaulters: 3,
//             },
//         ],
//         consumerTypes: ["residential", "agricultural"],
//     },
//     {
//         id: 13,
//         team: "Nu Team",
//         contact: "444-555-6667",
//         supportTeam: "Support Squad M",
//         supportContact: "444-333-2222",
//         date: "2025-05-13",
//         village: "Meadowbrook",
//         hamlet: [
//             {
//                 name: "Hamlet Meadow",
//                 id: 1301,
//                 countOfConsumers: { residential: 150, commercial: 12 },
//                 countOfDefaulters: 1,
//             },
//         ],
//         consumerTypes: ["residential", "commercial"],
//     },
//     {
//         id: 14,
//         team: "Xi Team",
//         contact: "555-666-7778",
//         supportTeam: "Support Squad N",
//         supportContact: "555-444-3333",
//         date: "2025-05-14",
//         village: "Evergreen",
//         hamlet: [
//             {
//                 name: "Hamlet Grove",
//                 id: 1401,
//                 countOfConsumers: { residential: 140, industrial: 20 },
//                 countOfDefaulters: 4,
//             },
//         ],
//         consumerTypes: ["residential", "industrial"],
//     },
//     {
//         id: 15,
//         team: "Omicron Team",
//         contact: "666-777-8889",
//         supportTeam: "Support Squad O",
//         supportContact: "666-555-4444",
//         date: "2025-05-15",
//         village: "Silverlake",
//         hamlet: [
//             {
//                 name: "Hamlet Shore",
//                 id: 1501,
//                 countOfConsumers: { residential: 160, agricultural: 25 },
//                 countOfDefaulters: 5,
//             },
//         ],
//         consumerTypes: ["residential", "agricultural"],
//     },
//     {
//         id: 16,
//         team: "Pi Team",
//         contact: "777-888-9990",
//         supportTeam: "Support Squad P",
//         supportContact: "777-666-5555",
//         date: "2025-05-16",
//         village: "Goldenfield",
//         hamlet: [
//             {
//                 name: "Hamlet Gold",
//                 id: 1601,
//                 countOfConsumers: { residential: 180, commercial: 20 },
//                 countOfDefaulters: 6,
//             },
//         ],
//         consumerTypes: ["residential", "commercial"],
//     },
//     {
//         id: 17,
//         team: "Rho Team",
//         contact: "888-999-0001",
//         supportTeam: "Support Squad Q",
//         supportContact: "888-777-6666",
//         date: "2025-05-17",
//         village: "Cedarville",
//         hamlet: [
//             {
//                 name: "Hamlet Cedar",
//                 id: 1701,
//                 countOfConsumers: { residential: 190, industrial: 30 },
//                 countOfDefaulters: 9,
//             },
//         ],
//         consumerTypes: ["residential", "industrial"],
//     },
//     {
//         id: 18,
//         team: "Sigma Team",
//         contact: "999-000-1112",
//         supportTeam: "Support Squad R",
//         supportContact: "999-888-7777",
//         date: "2025-05-18",
//         village: "Rosewood",
//         hamlet: [
//             {
//                 name: "Hamlet Rose",
//                 id: 1801,
//                 countOfConsumers: { residential: 200, agricultural: 35 },
//                 countOfDefaulters: 7,
//             },
//         ],
//         consumerTypes: ["residential", "agricultural"],
//     },
//     {
//         id: 19,
//         team: "Tau Team",
//         contact: "000-111-2223",
//         supportTeam: "Support Squad S",
//         supportContact: "000-999-8888",
//         date: "2025-05-19",
//         village: "Maplewood",
//         hamlet: [
//             {
//                 name: "Hamlet Maple",
//                 id: 1901,
//                 countOfConsumers: { residential: 210, commercial: 15 },
//                 countOfDefaulters: 3,
//             },
//         ],
//         consumerTypes: ["residential", "commercial"],
//     },
//     {
//         id: 20,
//         team: "Upsilon Team",
//         contact: "111-222-3334",
//         supportTeam: "Support Squad T",
//         supportContact: "111-000-9999",
//         date: "2025-05-20",
//         village: "Willowbrook",
//         hamlet: [
//             {
//                 name: "Hamlet Willow",
//                 id: 2001,
//                 countOfConsumers: { residential: 220, industrial: 25 },
//                 countOfDefaulters: 8,
//             },
//         ],
//         consumerTypes: ["residential", "industrial"],
//     },
// ];

type Props = UseQueryOptions<RecoveryPlan[]>;

// async function getRecoveryPlan() {
//     const rows = (await new Promise((resolve) =>
//         setTimeout(() => resolve(mockData), 1000)
//     )) as RecoveryPlan[];

//     return { success: true, message: "Rows retrieved successfully.", rows };
// }

async function getDefaultersReport({
    page,
    limit,
    district,
    village,
    hamlet,
    powerstation,
    startDate,
    endDate,
    month,
    year,
    minMonths = 1,
}: Filter) {
    try {
        const response = await GET(
            "/reading/defaulters-report-count-by-village",
            {
                page,
                limit,
                district,
                village,
                hamlet,
                powerstation,
                startDate,
                endDate,
                minDefaulterMonths: minMonths,
                month,
                year,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching defaulters report:", error);
        return error;
    }
}

async function getNumberOfCollections({
    page,
    limit,
    district,
    village,
    hamlet,
    powerstation,
    startDate,
    endDate,
}: Filter) {
    try {
        const response = await GET(
            "/reports/dashboard/no-of-connection-by-village",
            {
                page,
                limit,
                district,
                village,
                hamlet,
                powerstation,
                startDate,
                endDate,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching number of collections:", error);
        return error;
    }
}

type NumberOfConnectionsRes = {
    meterReport: {
        [village: string]: {
            [hamlet: string]: {
                hamletId: number;
                hamletName: string;
                villageName: string;
                types: {
                    typeId: number;
                    typeName: string;
                    typeCount: number;
                }[];
            };
        };
    };
};

type Filter = {
    page: number;
    limit: number;
    district: string;
    village: string[];
    hamlet: string[];
    powerstation: string;
    startDate: string;
    endDate: string;
    minMonths?: number;
    deps?: (string | number)[];
    month?: number;
    year?: number;
};

export default function useGetRecoveryPlan({
    page,
    limit,
    district,
    village,
    hamlet,
    powerstation,
    startDate,
    endDate,
    month,
    year,
    minMonths = 1,
    deps = [],
}: Filter) {
    const [recoveryPlan, setRecoveryPlan] = useState<RecoveryPlan[]>([]);
    const [consumerTypes, setConsumerTypes] = useState<string[]>([]);

    const {
        data: defaultersReport,
        isSuccess: defaultersReportSuccess,
        isLoading: defaultersReportLoading,
    } = useQuery(
        ["defaultersReport", ...deps],
        () =>
            getDefaultersReport({
                page,
                limit,
                district,
                village,
                hamlet,
                powerstation,
                startDate,
                endDate,
                minMonths,
                month,
                year,
            }),
        {
            // enabled: Boolean(district) && district !== "all",
        }
    );

    const {
        data: numberOfConnectionsByVillage,
        isSuccess: numberOfConnectionsSuccess,
        isLoading: numberOfConnectionsLoading,
    } = useQuery(
        ["numberOfConnectionsByVillage", ...deps],
        () =>
            getNumberOfCollections({
                page,
                limit,
                district,
                village,
                hamlet,
                powerstation,
                startDate,
                endDate,
            }),
        {
            // enabled: Boolean(district) && district !== "all",
            onSuccess: (data: NumberOfConnectionsRes) => {},
        }
    );

    // const response = useQuery({ queryFn: getRecoveryPlan });

    useEffect(() => {
        if (defaultersReportSuccess && numberOfConnectionsSuccess) {
            const ct: string[] = [];

            const numberOfConnectionsReport =
                numberOfConnectionsByVillage.meterReport;
            const villages = Object.entries(numberOfConnectionsReport);

            const data: RecoveryPlan[] = villages.map(
                ([villageName, village]) => {
                    const defaulterVillages: {
                        [hamlet: string]: {
                            hamletId: number;
                            hamletName: string;
                            villageName: string;
                            defaulterCount: number;
                        };
                    } = defaultersReport.report[villageName];

                    const hamlet: RecoveryPlan["hamlet"] = [];

                    const getCountOfConsumersObj = (
                        _villageName: string,
                        _hamletId: string | number
                    ) => {
                        try {
                            if (
                                !numberOfConnectionsReport[_villageName][
                                    _hamletId
                                ]?.types
                            ) {
                                console.log(_villageName, _hamletId);
                            }

                            return numberOfConnectionsReport[_villageName][
                                _hamletId
                            ].types.reduce((prev, curr) => {
                                ct.push(curr.typeName);
                                return {
                                    ...prev,
                                    [curr.typeName]: curr.typeCount,
                                };
                            }, {});
                        } catch (error) {
                            return {};
                        }
                    };

                    const hamletData = Object.values(
                        numberOfConnectionsReport[villageName]
                    ).map((item) => {
                        try {
                            return {
                                name: item.hamletName,
                                id: item.hamletId,
                                countOfDefaulters: defaulterVillages[
                                    item.hamletId
                                ]
                                    ? defaulterVillages[item.hamletId]
                                          .defaulterCount
                                    : 0,
                                countOfConsumers: getCountOfConsumersObj(
                                    item.villageName,
                                    item.hamletId
                                ),
                            };
                        } catch (error) {
                            console.error(
                                "Error in hamletData mapping:",
                                error
                            );

                            const { hamletName, hamletId } =
                                numberOfConnectionsReport[villageName][
                                    item.hamletId
                                ];

                            return {
                                name: hamletName,
                                id: hamletId,
                                countOfDefaulters: 0,
                                countOfConsumers: getCountOfConsumersObj(
                                    villageName,
                                    hamletId
                                ),
                            };
                        }
                    });

                    // console.log("defaulterVillages", defaulterVillages[item.hamletId]);

                    hamlet.push(...hamletData);

                    return {
                        village: villageName,
                        date: "",
                        // consumerTypes: [],
                        hamlet,
                    };
                }
            );

            setConsumerTypes(
                Object.keys(
                    ct.reduce((prev, curr) => ({ ...prev, [curr]: curr }), {})
                )
            );

            setRecoveryPlan(data);
        }
    }, [defaultersReportSuccess, numberOfConnectionsSuccess]);

    return {
        data: recoveryPlan,
        isLoading: defaultersReportLoading || numberOfConnectionsLoading,
        consumerTypes,
    };
}
